import styled, { keyframes } from "styled-components";
import { theme } from "../../helpers/theme";

const motion1 = () => keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`;

const motion2 = () => keyframes`
   0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(40px, 0);
  }
`;
const motion3 = () => keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;

const EllipsisSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: ${(p: any) => `${p.size}${p.sizeUnit}`};
  height: ${(p: any) => `${p.size}${p.sizeUnit}`};
  div {
    position: absolute;
    top: 27px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: ${(props: any) => props.color};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 10px;
    animation: ${motion1()} 0.6s infinite;
  }
  div:nth-child(2) {
    left: 20px;
    animation: ${motion2()} 0.6s infinite;
  }
  div:nth-child(3) {
    left: 60px;
    animation: ${motion2()} 0.6s infinite;
  }
  div:nth-child(4) {
    left: 100px;
    animation: ${motion3()} 0.6s infinite;
  }
`;

export const Ellipsis = (props: EllipsisProps) => (
  <EllipsisSpinner {...props}>
    <div />
    <div />
    <div />
    <div />
  </EllipsisSpinner>
);

Ellipsis.defaultProps = {
  size: 135,
  sizeUnit: "px",
  color: theme.colors.blue01_active,
};

export interface EllipsisProps {
  size?: number;
  color?: string;
  sizeUnit?: string;
}
